import bowel from './img/bowel.jpg'
import breast from './img/breast.jpg'
import heart from './img/heart.jpg'
import other from './img/other.jpg'
import skin from './img/skin.jpg'

// Bowel Cancer Screening - bowel
// Breast Cancer Screening - breast
// Heart Health Screening - heart
// Skin Cancer - skin
// Low risk - low
// Other Conversations with your GP - other

const getImage = (image) => {
  switch (image) {
    case 'bowel':
      return bowel
    case 'heart':
      return heart
    case 'skin':
      return skin
    case 'breast':
      return breast
    // case low?
    default:
      // other conversations with your gp
      return other
  }
}

export default getImage
